/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![HeadphonesSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACJ0lEQVR4nMWVS2sUQRDHO0RNQBMPPk7GQ8SzR72Nl8jATlfVBHqr1l2dg7ioNx8XE5C9evdLCAY9+CAHv4CQkFwU4wvxcRPiI3jyQffOrr2PmcwyQgoGZnq6f1Vd/a9qpXbSjDH7I6xdAZQHQPIekH+6x74T39fEl+0cf00U1Q4CyjIQ384EB0kyqZFbQPwDSP7kPRrlexw3DnfhxOvuH8ryUDgiz3QnkfwGlMeapFGZPzsbBMEuY8weIj4GUD2vkR9qkpsDcOJ1+50Bl49pZM91XD1VJJWF4GEYTgDKWnt7/DQM69P/DW4NiG91IgeAqTLwOD0TL/r6tD0sl3OQk2XgGnnBsowx+7zo5VKamidl4NY08aN2JviC6higLLlBkoYqmXNNkqQyXfrngOStHbRSLAO3VpmvHU+zsaE6BiRbdtBqXJVUS5Akk2kNbXkO2hWb5SA05lAhKXoONMpmd1CTvOttAfy1k65om8gR+bSrdpQvPQzkN/4O7vX2F24VgQPIVSftYX0K+a63A26OCo+Iz2jkXzmN8KIXCUxpkm9F4UTnDmjiTzkddnNurrF34CDz4Ig8090x8p38Fs4Lo5Z/SyN/9hx8yIQTrzabzd0jwaGvcDTKy4zUvI7j+pHR4eQWX+9TT59q5FkUmaMDcGPMOKCs9MMrcfWE1TIgv4iQbyilxrxlY0B8DUheuTnEi/a2G5p3d9HYWwxlJa9CS5l1khlBSfsLq6Hhsjo7jc8AAAAASUVORK5CYII=)
 */
export const HeadphonesSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20ZM17.06 2.94a.48.48 0 0 0-.11-.77A11 11 0 0 0 2.18 16.94c.14.3.53.35.76.12l3.2-3.2c.25-.25.15-.68-.2-.76a5 5 0 0 0-1.02-.1H3.05a9 9 0 0 1 12.66-9.2c.2.09.44.05.59-.1l.76-.76ZM20.2 8.28a.52.52 0 0 1 .1-.58l.76-.76a.48.48 0 0 1 .77.11 11 11 0 0 1-4.5 14.57c-1.27.71-2.73.23-3.55-.74a3.1 3.1 0 0 1-.17-3.78l1.38-1.97a5 5 0 0 1 4.1-2.13h1.86a9.1 9.1 0 0 0-.75-4.72ZM10.1 17.9c.25-.25.65-.18.74.14a3.1 3.1 0 0 1-.62 2.84 2.85 2.85 0 0 1-3.55.74.16.16 0 0 1-.04-.25l3.48-3.48Z"
        className={colorClass}
      />
    </svg>
  );
};
